<template>
  <a-config-provider :locale="locale">
    <div id="app">
      <Loading v-if="loading" />
      <router-view />
    </div>
  </a-config-provider>
</template>
<script>
  import { mapState } from 'vuex'
  import Loading from '@comp/loading'
  import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
  import zhHK from 'ant-design-vue/lib/locale-provider/zh_TW'

  const localeVal =
    localStorage.getItem('locale') == 'zh'
      ? zhCN
      : localStorage.getItem('locale') == 'tw'
        ? zhHK
        : null
  export default {
    components: {
      Loading
    },
    data() {
      return {
        user: {},
        locale: localeVal || zhCN
      }
    },
    computed: {
      ...mapState({ loading: state => state.loading }) // 整个页面的loading
    },
    created() {}
  }
</script>
<style>
  html,
  body,
  #app {
    width: 100%;
    height: 100%;
    min-width: 1400px;
  }
</style>
